import * as React from 'react';
export const negativeSvg = React.forwardRef(function negativeSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M1 8c0-.483.392-.875.875-.875h12.25a.875.875 0 0 1 0 1.75H1.875A.875.875 0 0 1 1 8Z',
    }),
  );
});
negativeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var negative = {
  category: 'icon',
  colorable: true,
  name: 'negative',
  svg: negativeSvg,
};
